import React from 'react';
import PropTypes from 'prop-types';
import { downloadSupplierImportTemplateCsv } from '../utils/supplier-import-csv-template';

const FILENAME_ADMIN = 'suppliers-import-template.csv';
const FILENAME_CLIENT = 'suppliers-client-import-template.csv';

/**
 * Help text and template download for supplier CSV import modals (admin vs client-scoped).
 */
const SupplierImportHelp = ({ data, variant }) => {
  const isClient = variant === 'client';
  const baselineKey = isClient
    ? 'client_table.csv_baseline_columns_client_import'
    : 'supplier_table.csv_baseline_columns_admin';
  const csvHeaderKey = isClient
    ? 'client_table.csv_template_header_row'
    : 'supplier_table.csv_template_header_row';
  const titleKey = isClient ? 'client_table.csv_file_format' : 'supplier_table.csv_file_format';

  const onDownload = () => {
    downloadSupplierImportTemplateCsv(
      data.t.read(csvHeaderKey),
      isClient ? FILENAME_CLIENT : FILENAME_ADMIN
    );
  };

  return (
    <div>
      <p className="mb-2 font-weight-medium">{data.t.read(titleKey)}</p>
      <div className="card p-2">
        <p className="mb-2">{data.t.read(baselineKey)}</p>
        <p className="mb-2">{data.t.read('supplier_table.csv_optional_trailer_help')}</p>
        <p className="mb-0 text-muted small">{data.t.read('supplier_table.csv_delimiter_note')}</p>
      </div>
      <div className="mt-2">
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={onDownload}
        >
          {data.t.read('supplier_table.download_csv_template')}
        </button>
      </div>
    </div>
  );
};

SupplierImportHelp.propTypes = {
  data: PropTypes.shape({
    t: PropTypes.shape({
      read: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
  variant: PropTypes.oneOf(['admin', 'client']).isRequired,
};

export default SupplierImportHelp;
